// Welcome.js
import React from 'react';
import './News.css';

export default function Welcome() {
  return (
    <div className="page-container">
      <h1 className="news-title">Welcome to ChronoTech Robotics</h1>
      <p className="news-meta">Published by Mohit Singh - Jan 12, 2026</p>

      <p>
        At ChronoTech Robotics, our mission is to inspire the next generation of young engineers through hands-on learning, innovative kits, and live Zoom-based robotics classes. 
        We believe that every child should have access to fun, engaging STEM education,  whether they’re just starting out or building their own intelligent machines.
      </p>

      <p>
        Our flagship program, <strong>Robo Kids Learning</strong>, gives students everything they need to get started:
        a robotics starter kit shipped directly to their home, and live guided instruction from an experienced instructor. Classes are hosted virtually and
        designed to be friendly, beginner-accessible, and exciting.
      </p>

      <p>
        For those who want to go beyond the basics, our <strong>Level X: Custom Robotics Innovation Lab</strong> allows students to work on open-ended projects,
        guided by an instructor to help turn ideas into working prototypes. Whether your child wants to build a smart rover, a walking spider robot, or a custom sensor-triggered alarm,
        they’ll learn real engineering and coding skills along the way.
      </p>

      <p>
        ChronoTech Robotics was founded on the idea that learning robotics should be creative, affordable, and inspiring, not intimidating or restricted to a classroom. 
        That’s why all of our classes are online, and each student receives a full kit with tools and parts. We also offer support, project updates, and a growing
        library of guides and tutorials.
      </p>

      <p>
        We’re excited to welcome you to our community of builders, tinkerers, and young inventors.
        Let’s build the future together,  one robot at a time.
      </p>

      <p className="news-signoff">– Mohit Singh, Founder</p>
    </div>
  );
}
